import * as React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Label from '../../components/abstractObjects/Label'
import {
    Translation
} from '../../features/translations/getTranslation'


export const RadioYesNoNull = function (props: any) {
    return (
        <React.Fragment>
            <RadioGroup row aria-label={props.ariaLabel} name={props.name} value={props.value === null ? null : props.value === "false" || props.value === false ? "false" : "" + props.value} onChange={props.onChange} style={{ width: '100%' }}>
                <Grid item xs={12} sm={6}>{props.text !== null ? <Label text={Translation.t(props.text)} /> : ''}</Grid>
                <Grid item xs={12} sm={6}>
                    <FormControlLabel value="true" control={<Radio style={{ color: '#1cabe2' }} />} disabled={props.readonly} label={Translation.t("YES")} />
                    <FormControlLabel value="false" control={<Radio style={{ color: '#1cabe2' }} />} disabled={props.readonly} label={Translation.t("NO")} />
                </Grid>
            </RadioGroup>
            {props.error ? <p className="errorMessage">{Translation.t(props.error)}</p> : null}
        </React.Fragment>
    );
};

export const RadioYesNo = function (props: any) {
    return (
        <React.Fragment>
            <RadioGroup row aria-label={props.ariaLabel} name={props.name} value={props.value === null ? "false" : props.value} onChange={props.onChange} style={{ width: '100%' }}>
                <Grid item xs={12} sm={6}>{props.text !== null ? <Label text={Translation.t(props.text)} /> : ''}</Grid>
                <Grid item xs={12} sm={6}>
                    <FormControlLabel value="true" control={<Radio style={{ color: '#1cabe2' }} />} disabled={props.readonly} label={Translation.t("YES")} />
                    <FormControlLabel value="false" control={<Radio style={{ color: '#1cabe2' }} />} disabled={props.readonly} label={Translation.t("NO")} />
                </Grid>
            </RadioGroup>
            {props.error ? <p className="errorMessage">{Translation.t(props.error)}</p> : null}
        </React.Fragment>
    );
};

export default RadioYesNo; 
